module.exports = __webpack_public_path__ + "static/media/GbolahanAdamolekun.43517937.jpg";